import React from 'react';
import { ProFormaIntlProvider, withProFormaIntlProvider } from '@atlassian/proforma-common-core/intl-provider';
import * as i18nMessages from '../i18n';
export var PackageIntlProvider = function PackageIntlProvider(_ref) {
  var children = _ref.children,
    locale = _ref.locale;
  return /*#__PURE__*/React.createElement(ProFormaIntlProvider, {
    i18nMessages: i18nMessages,
    locale: locale
  }, children);
};
export var withPackageIntlProvider = function withPackageIntlProvider(WrappedComponent) {
  return withProFormaIntlProvider(i18nMessages, WrappedComponent);
};